import { render } from "./contentCategory.vue?vue&type=template&id=a01047e8"
import script from "./contentCategory.vue?vue&type=script&lang=js"
export * from "./contentCategory.vue?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contentCenter/contentCategory.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a01047e8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a01047e8', __exports__)) {
    console.log('reload')
    api.reload('a01047e8', __exports__)
  }
  
  module.hot.accept("./contentCategory.vue?vue&type=template&id=a01047e8", () => {
    console.log('re-render')
    api.rerender('a01047e8', render)
  })

}


export default __exports__